import 'css-chunksrc/client/common/filterMenu/zones/zone/styles.scss';export default {
  "header": "_header_1paxi_1",
  "icon": "_icon_1paxi_10",
  "name": "_name_1paxi_17",
  "projects": "_projects_1paxi_24"
};